"use client"

import { renderToString } from 'react-dom/server';
import jsPDF from 'jspdf';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';

import React, { useState, useEffect, useRef, CSSProperties } from 'react';

import classNames from 'classnames';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { FilterMatchMode, FilterOperator } from 'primereact/api';


import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Toast } from 'primereact/toast';
//import { InputTextarea } from 'primereact/inputtextarea';
//import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Tag } from 'primereact/tag';

import { Rating } from 'primereact/rating';
import { FileUpload } from 'primereact/fileupload';

import { MultiSelect } from 'primereact/multiselect';

import { Toolbar } from 'primereact/toolbar';
import { Skeleton } from 'primereact/skeleton';
import { SelectButton } from 'primereact/selectbutton';
import { OverlayPanel } from 'primereact/overlaypanel';
import lodash, { replace } from "lodash";


import { GenericaSistemaService } from '../service/GenericaSistemaService';
import { PlantillaService } from '../service/PlantillaService';

import AuthStorage from '../storage/AuthStorage';


import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';

import { render } from 'preact/compat';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { Dropdown } from 'primereact/dropdown';




import { Knob } from 'primereact/knob';
import { ProgressBar } from 'primereact/progressbar';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';

import ContentTemplate from './ContentTemplate';


import GeneratePdf from '../templates/GeneratePdf';


/*
  
para las url externas, hay que manejar los queryparams como base64 con hash
import crypto from "crypto-js";
crypto.SHA512(plain_text).toString()

var encodedStringBtoA = btoa(decodedStringBtoA);
var decodedStringAtoB = atob(encodedStringAtoB);

*/
const Reporte = (props) => {

    console.log("Reporte");

    const _ = lodash;

    const dt = useRef(null);
    const formRef = useRef(null);
    const pdfRef = useRef(null);

    const getPayloadRefQueryParam = () => {

        if (payLoadRef.current == null && window.location.search !== null) {

            const queryParams = new URLSearchParams(window.location.search);
            let payloadDecoded = queryParams.get("payload") || "";

            if (payloadDecoded !== "") {

                let payloadStr = Buffer.from(payloadDecoded, 'base64') + "";//.toString('ascii');

                const payload = JSON.parse(payloadStr);
                console.log("payload, ", payload);
                payLoadRef.current = { payloadDecoded: payloadDecoded, hash: payload.hash, bodyContentPayload: payload.bodyContentPayload }
            }

        }

    }

    const payLoadRef = useRef(null);

    getPayloadRefQueryParam();

    const formFacturaRef = useRef(null);
    const overlayPanelRef = useRef(null);

    const codModulo = "DATATABLE_GENERICA";

    const plantillaService = new PlantillaService();
    const genericaSistemaService = new GenericaSistemaService();

    const authStorage = new AuthStorage(window.location.pathname);

    const dataConfigSubdomain = authStorage.getConfigSubdomain();
    const userDetails = authStorage.GetCurrentUser();

    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;
    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [canEditRow, setCanEditRow] = useState(false);

    const urlFullLogoLoginDefault = "assets/layout/images/logo-login.png";
    const urlFullLogoLogin = urlLogoLogin ? process.env.NEXT_PUBLIC_URL_API + urlLogoLogin : urlFullLogoLoginDefault;
    const [urlExterna, setUrlExterna] = useState(urlFullLogoLogin);
    const [comodin, setComodin] = useState(0);

    const [optionsSelectButton, setOptionsSelectButton] = useState(undefined);

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const prevSelectedTipoGenericaRef = useRef(undefined);
    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    //const [selectedGenericasSistema, setSelectedGenericasSistema] = useState({'cg':'', 'cti':'', 'ctiTgTexto':'', 'ctiTg':'', 'ctiTgTexto':'', 'idEmpresa':0, 'idioma':'', 'orden':0, 'tg':''});
    const [selectedGenericasSistema, setSelectedGenericasSistema] = useState(null);



    //const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);


    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    const [metadataGenericaFormulario, setMetadataGenericaFormulario] = useState([]);
    const [metadataGenericaFormularioFactura, setMetadataGenericaFormularioFactura] = useState([]);

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [genericaFormulario, setGenericaFormulario] = useState(emptyGenericaSistemaInit);

    const [metadataGenericaSistemaRef, setMetadataGenericaSistemaRef] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);


    const [genericasSistema, setGenericasSistema] = useState(null);

    const lazyParamInit = {
        first: 0,
        rows: 10000,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const [lazyParams, setLazyParams] = useState(undefined);
    const [lazyParamsInitSelected, setLazyParamsInitSelected] = useState({ ...lazyParamInit });

    if (selectedTipoGenerica == undefined && payLoadRef.current !== null && payLoadRef.current.bodyContentPayload !== null) {
        setSelectedTipoGenerica({ ...payLoadRef.current.bodyContentPayload.item.selectedTipoGenerica });
    }
    else if (selectedTipoGenerica == undefined && props.selectedTipoGenerica !== undefined) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else if (props.selectedTipoGenerica !== undefined) {

        if ((props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg)) {
            setSelectedTipoGenerica(props.selectedTipoGenerica);
        }
        else if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            let newSelectedTipoGenerica = { ...selectedTipoGenerica, filtroUts: { ...props.selectedTipoGenerica.filtroUts } };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {
            let newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }

    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }


    useEffect(() => {
        LoadEtiquetas();
    }, []);

    const LoadEtiquetas = async => {

        plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, "ReportePowerBI").then(data => {
            setEtiquetasModulo(data);
        });

    }

    useEffect(() => {

        let prevselectedTipoGenerica = { ...selectedTipoGenerica }

        if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined) {
            LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            prevselectedTipoGenerica["intentoMetadata"] = 1;
        }
        else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined) {

            if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 1;
            }
            else if (metadataGenericaSistema.length == 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
            }
            else if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && optionsSelectButton === undefined) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            }
            else {
                setLazyParams({ ...lazyParams });
            }

        }

        prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

    }, [selectedTipoGenerica])

    const createHeaderGenerica = (objecto) => {

        let headers = "";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "string": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${meta.campo}":{ "value": "", "matchMode": "equals","ref": null }`; break;
            }

        });

        headers += '}';



        return (JSON.parse('' + headers + ''));
    }


    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "" && (selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

            genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                let newSelectedTipoGenerica = data.data;

                if (selectedTipoGenerica.filtroUts) {
                    newSelectedTipoGenerica.filtroUts = selectedTipoGenerica.filtroUts;
                    newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                }
                if (selectedTipoGenerica.version) {
                    newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                }

                console.log("newSelectedTipoGenerica, ", newSelectedTipoGenerica);

                setSelectedTipoGenerica(newSelectedTipoGenerica);


            });
        }

        //if ( selectedTipoGenerica.operaciones!==undefined && metadataGenericaSistema.operaciones.length>0){
        if (metadataGenericaSistema.length === 0) {

            await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {

                let columnaIdentificadorOculta = "tg";
                let prefijo = '000000';
                let TamSufijo = 4;
                data = data.sort(function (a, b) {
                    let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                    let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                    return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                });

                data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                let _metadataGenericaSistemaTgOperaciones = data.map(x => x);



                setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                data = data.filter(col => col.tg === _tg);

                let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                let dataForm = metadataImprimible;
                let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                let newSelectedColumns = metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)

                if (dataRef.length > 0) {

                    setSelectedColumns([]);

                    setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                    lazyParamInit.filters = createHeaderGenerica(dataForm);
                    let newLazyParamInit = { ...lazyParamInit };


                    setMetadataGenericaSistema(data);

                    setMetadataGenericaSistemaRef(dataRef);
                    setMetadataGenericaFormulario(dataForm);
                    setMetadataGenericaFormularioFactura({ ...dataForm });


                    setLazyParams({ ...newLazyParamInit });
                    setLazyParamsInitSelected({ ...newLazyParamInit });
                    setSelectedColumns(newSelectedColumns);

                    setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                }

            });

            if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && optionsSelectButton === undefined) {

                await genericaSistemaService.GetOptionsSelectButtonDeTg(_tg, idEmpresa, idioma, userName, selectedTipoGenerica.filtroUts).then(data => {

                    setOptionsSelectButton(data);
                });
            }
            else if (selectedTipoGenerica.tg !== "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA") {
                setOptionsSelectButton([]);
            }



        }

    }



    const cols = [
        { field: 'code', header: 'Code' },
        { field: 'name', header: 'Name' },
        { field: 'category', header: 'Category' },
        { field: 'quantity', header: 'Quantity' }
    ];

    const exportColumns = selectedColumns.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0)
        .map((col) => ({ title: col.ctiTexto, dataKey: col.campo }));

    ///columnsDataTable



    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(genericasSistema.map(x => x.uts));
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'products');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    //<Button icon="pi pi-upload" className="p-button-rounded p-button-secondary mr-1" aria-label='Exportar' tooltip='Exportar' onClick={exportCSV} />



    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";
        item['tg'] = metadata.length > 0 ? metadata[0].tg : "";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;

            else {

                let newVal = "";
                if (x.tipoDato === "date")
                    newVal = 0;
                else if (x.tipoDato === "int") newVal = 0;
                else if (x.tipoDato === "double") newVal = 0.0;
                else if (x.tipoDato === "money") newVal = 0;

                if (selectedTipoGenerica.filtroUts !== undefined && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo)) {
                    newVal = selectedTipoGenerica.filtroUts[x.campo];
                    //console.log("newVal,", x.campo,newVal);
                    //console.log("selectedTipoGenerica,", selectedTipoGenerica);
                }

                //item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }
                item['uts'][`${x.campo}`] = newVal
            }
        });

        return item;

    }

    useEffect(() => {

        if (lazyParams !== undefined && selectedTipoGenerica !== undefined && selectedTipoGenerica.operaciones !== undefined) {
            setSelectedGenericasSistema(null);
            loadLazyData();
        }

    }, [lazyParams])


    const loadLazyData = () => {
        setLoading(true);

        //if (loadLazyTimeout) {
        //clearTimeout(loadLazyTimeout);
        //}

        let filtroUts = {};

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                }
            }
        }

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        genericaSistemaService.getGenericasSistemaDS(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);

            console.log("getGenericasSistemaDS", data);
            if (selectedTipoGenerica.tipoTabla == "10" && data.metadata.length > 0 && ((metadataGenericaSistema.find(x => x.idTipoAtributo >= 999) === undefined) && (data.metadata.find(x => x.idTipoAtributo >= 999) !== undefined))) {
                //if ( selectedTipoGenerica.tipoTabla =="10" && data.metadata.length>0 && (( metadataGenericaSistema.length===0) || ( metadataGenericaSistema.length>0 && data.metadata[0].tg !== metadataGenericaSistema[0].tg )) ){

                let dataRef = data.metadata.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                let _metadataGenericaSistemaTgOperaciones = data.metadata;
                let newSelectedColumns = data.metadata;//metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                let dataForm = newSelectedColumns;

                if (dataRef.length > 0) {

                    setSelectedColumns([]);

                    setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                    lazyParamInit.filters = createHeaderGenerica(dataForm);
                    let newLazyParamInit = Object.assign({}, lazyParamInit);

                    setMetadataGenericaSistema(data.metadata);

                    setMetadataGenericaSistemaRef(dataRef);


                    setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                }
            }

            setGenericasSistema(data.data)
            setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
            setLoading(false);
            setComodin(prev => prev + 1);



        });


        /*
        if (selectedTipoGenerica["referencia1"] !== undefined) {
            let newUrlExterna = selectedTipoGenerica["referencia1"];
            let tieneVariablesExternas = false;
            let contieneParametros = newUrlExterna.indexOf("]]") > 0;
            let contieneValoresFiltroUts = selectedTipoGenerica.filtroUts !== undefined && Object.keys(selectedTipoGenerica.filtroUts).length > 0;

            if (contieneParametros && contieneValoresFiltroUts) {

                for (const campo in selectedTipoGenerica.filtroUts) {

                    let _metadata = metadataGenericaSistema.find(x => x.campo === campo);

                    if (_metadata !== undefined) {
                        if (_metadata.idTipoAtributo === 110 && selectedTipoGenerica.filtroUts[campo] !== undefined && selectedTipoGenerica.filtroUts[campo] !== "") {
                            newUrlExterna = replace(newUrlExterna,  _metadata.campoOrigen, selectedTipoGenerica.filtroUts[campo]);
                            filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                        }
                        else {
                            newUrlExterna = urlFullLogoLogin;
                            break;
                        }
                        //else {
                        //    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                        //}

                    }
                }

            }
            else if (contieneParametros === false) {
                newUrlExterna = selectedTipoGenerica["referencia1"];
            }
            else
                newUrlExterna = urlFullLogoLogin;

            if (newUrlExterna !== urlExterna)
                setUrlExterna(newUrlExterna);

        }

        */

        //urlExterna


        setGenericasSistema([]);

        /*
        genericaSistemaService.getGenericasSistema(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);

            setGenericasSistema(data.data)
            setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
            setLoading(false);
        });
        */
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const onSelectAllChange = (event) => {
        /*const selectAll = event.checked;

        if (selectAll) {
            genericaSistemaService.getGenericasSistema(selectedTipoGenerica.tg).then(data => {
                setSelectAll(true);
                setSelectedGenericasSistema(data.genericas);
            });
        }
        else {
            setSelectAll(false);
            setSelectedGenericasSistema([]);
        }*/
    }

    const representativeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <img alt='cambio' src={`images/avatar/ca`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} width={32} style={{ verticalAlign: 'middle' }} />
                <span className="image-text">cambio</span>
            </React.Fragment>
        );
    }


    const countryBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <img alt="flag" src="/images/flag/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={`flag flag-sd`} width={30} />
                <span className="image-text">cambio</span>
            </React.Fragment>
        );
    }

    const booleanRowFilterTemplate = (options) => {

        //const campo =  selectedColumns.find(et => et.campo ===options.field);
        const metadataRef = metadataGenericaSistemaRef.find(et => et.campo === options.field);

        if (metadataRef === undefined)
            return <TriStateCheckbox id={`filter${options.field}`} value={options.value} ref={e => metadataRef.columnFiltroRef = e} onChange={(e) => options.filterCallback(e.value)} />
        else
            return <TriStateCheckbox id={`filter${metadataRef.campo + metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} value={options.value} onChange={(e) => options.filterCallback(e.value)} />

    }

    //<InputNumber value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} mode="currency" currency="USD" locale="en-US" />
    const ColumnFilterTemplate = (options) => {


        //const campo =  selectedColumns.find(et => et.campo ===options.field);
        //const metadataRef =  metadataGenericaSistemaRef.find(et => et.campo ===options.field);
        const metadata = metadataGenericaSistema.find(et => et.campo === options.field);
        const metaColumn = selectedColumns.find(et => et.campo === options.field);

        const lazyParamCampo = Object.keys(lazyParams.filters).includes(options.field) ? lazyParams.filters[`${metadata.campo}`] : null;
        const val = lazyParamCampo !== null ? lazyParamCampo.value : "";

        switch (metadata.tipoDato) {
            case "boolean": return <TriStateCheckbox id={`filter${metadata.tg + '-' + metadata.campo}`} value={options.value} onChange={(e) => options.filterCallback(e.value)} />; break;
            case "int": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            case "double": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." mode="decimal" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />); break;
            case "money": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." mode="currency" currency="COP" locale="es-CO" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            default: return (<InputText id={`filter${metadata.tg + '-' + metadata.campo}`} ref={e => metaColumn.columnRef = e} placeholder="Search..." type="search" style={{ paddingLeft: '0.5rem', minWidth: '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} />); break;
        }

        //return <TriStateCheckbox id ={`filter${metadataRef.campo+metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} value={options.value} onChange={(e) => options.filterCallback(e.value)}   />

        //if (metadataRef=== undefined)
        //return (<InputText id ={`filter${options.field}`} type="search" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} placeholder="Search..." />)
        //else
        //return (<InputText id ={`filter${metadataRef.campo+metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} type="search" style={{paddingLeft: '0.5rem', 'minWidth': '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} placeholder="Search..." />)

    }

    const onfilterapply = (options, event) => {
        options.filterApplyCallback(event.target.value);
    }

    const columnBodyTemplate = (tipoDato, formatoDato) => {

        if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && formatoDato === "ACA_UNIDAD_RA_CRITERIO_NIVEL") {
            return selectedOptionBodyTemplate;
        }


        switch (tipoDato) {
            case 'boolean':
                return booleanBodyTemplate
            case 'int':
                return intBodyTemplate
            case 'money':
                return moneyBodyTemplate
            case 'tags':
                return tagsBodyTemplate
            case 'text':
                return textRichBodyTemplate
            case 'date':
                return dateBodyTemplate
            default:
                return textBodyTemplate
        }
    }


    const selectedOptionBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === "ctiTexto" + column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }
        if (val === "")
            val = "Pendiente";

        return <span >{val}</span>;

    }

    const tagsBodyTemplate = (rowData, column) => {

        let tagsString = rowData.uts[column.field];

        if (tagsString !== undefined && tagsString !== "") {

            let tags = JSON.parse('' + tagsString + '');

            if (tags !== null) {

                return (
                    <div class="grid">

                        {
                            tags.map(x =>
                                <Tag className='col' style={{ backgroundColor: x.color }}>
                                    <div className="flex align-items-center gap-2">
                                        <span className="text-base">{x.ctiTexto}</span>
                                    </div>
                                </Tag>

                            )
                        }


                    </div>
                );

            }
            else {
                return (<></>);
            }



        }
        else
            return (<></>);


    }

    const booleanBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = (typeof rowData.uts[column.field] === "boolean") ? rowData.uts[column.field] : rowData.uts[column.field].toLowerCase() === "true";
        }

        //return <i className={classNames('pi', val ===true? 'true-icon pi-check-circle': 'false-icon pi-times-circle' )}></i>;
        return (<Checkbox checked={val} readOnly ></Checkbox>);
    }

    const intBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{Math.trunc(val)}</span>;
    }

    const moneyBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</span>;
    }

    const textBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val}</span>;
    }

    const textRichBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return (
            <div dangerouslySetInnerHTML={{ __html: val }} />
        );
    }

    const dateBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleDateString() + " " + val.toLocaleTimeString()}</span>;
    }

    const ConvertTipoDatoADateTypeTabla = (tipoDato) => {

        let res = "text";

        switch (tipoDato) {
            case "date": res = "date"; break;
            case "int": res = "numeric"; break;
            case "double": res = "numeric"; break;
            case "money": res = "numeric"; break;
            case "boolean": res = "boolean"; break;
            default: res = "text"; break;
        }

        return res;
    }

    const cellEditor = (options) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === options.field)

        if (metadata.tipoDato === 'date') return textEditor(options);
        else if (metadata.tipoDato === 'int') return intEditor(options);
        else if (metadata.tipoDato === 'double') return doubleEditor(options);
        else if (metadata.tipoDato === 'money') return moneyEditor(options);
        else if (metadata.tipoDato === 'NOTARA') return selectButtonEditor(options);
        else return textEditor(options);
    };

    const selectButtonEditor = (options) => {
        let items = [
            { name: 'Option 1', value: 1 }
        ];

        console.log("options, ", options);
        console.log("optionsSelectButton, ", optionsSelectButton);

        let criterioRA = options.rowData.uts['criterioRA'];

        items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts['criterioRA'] === criterioRA).map(x => ({ value: x.uts[''], 'name': x.uts['ctiTextonivelDesempenoRA'] }));

        return (
            <SelectButton value={options.value} optionLabel="name" onChange={(e) => options.editorCallback(e.value)} options={items} multiple />
        );

    };

    const dateEditor = (options) => {
        return <Calendar showButtonBar yearNavigator={false} showIcon dateFormat="dd/mm/yy" value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
    };

    const moneyEditor = (options) => {
        return <InputNumber value={options.value} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value); }} mode="currency" currency="COP" locale="es-CO" />;
    };

    const intEditor = (options) => {
        return <InputNumber value={options.value} onValueChange={(e) => options.editorCallback(e.value)} />;
    };

    const doubleEditor = (options) => {
        return <InputNumber value={options.value} onValueChange={(e) => options.editorCallback(e.value)} />;
    };

    const textEditor = (options) => {
        return <InputText type="text" value={options.value || options.rowData.uts[options.field]} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const isPositiveInteger = (val) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };


    const arrayTemplate = [{}, {}, {}, {}, {}, {}];
    const bodyTemplate = () => {
        return <Skeleton></Skeleton>
    }



    const [sortKey, setSortKey] = useState('');
    const [sortOrder, setSortOrder] = useState(0);
    const [sortField, setSortField] = useState('');
    const sortOptions = [
        { label: 'Mayor a menor', value: '!avance' },
        { label: 'Menor a Mayor', value: 'avance' }
    ];

    const onSortChange = (event) => {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            setSortOrder(-1);
            setSortField(`uts.${value.substring(1, value.length)}`);
            setSortKey(`uts.${value}`);
        } else {
            setSortOrder(1);
            setSortField(`uts.${value}`);
            setSortKey(`uts.${value}`);
        }
    };


    //console.log("selectedTipoGenerica, ",selectedTipoGenerica, "metadataGenericaSistema, ",metadataGenericaSistema,"genericaFormulario, ",genericaFormulario);

    ////<img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" src={`https://primefaces.org/cdn/primereact/images/product/${product.image}`} alt={generica.ctiTexto} />
    const itemTemplate = (generica) => {

        //let porcentaje = generica.uts.avance / generica.uts.meta * 100;

        return (
            <div className="col-12 sm:col-6 lg:col-12 xl:col-4 p-2">
                <div className="p-4 border-1 surface-border surface-card border-round">
                    <span className="font-bold">Cumplimiento de actividades de {generica.uts["ctiTexto"]}</span>
                    <ProgressBar value={generica.uts["cumplimiento"]}></ProgressBar>
                </div>
            </div>

        );
    };

    const header = () => {
        return <Dropdown options={sortOptions} value={sortKey} optionLabel="label" placeholder="Ordenar por avance" onChange={onSortChange} className="w-full sm:w-14rem" />;
    };

    const exportPdf = () => {
        genericasSistema.map(x => x.uts)

        const pdfDoc = new jsPDF('p', 'pt', 'a4');

        import('jspdf-autotable').then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = 'Report 2014';
                const footer = `Page ${i} of ${pageCount}`;

                // Header
                pdfDoc.text(header, 40, 15, { baseline: 'top' });

                // Footer
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, { baseline: 'bottom' });

                // doc.autoTable(exportColumns, genericasSistema.map(x => x.uts));
            }
        }).then(() => {
            pdfDoc.save('filePDF.pdf');
        });


    };

    const handleDownload = () => {
        const content = pdfRef.current;

        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(async () => {
                const doc = new jsPDF.default(0, 0);

                doc.format = "a4";
                doc.unit = "px";

                //let html = renderToString(<ContentReport />);
                let g = "";
                doc.setFont("Anton-Regular", "normal");

                await doc.html(pdfRef.current, {
                    callback: function (doc) {
                        doc.save('sample.pdf');
                    }
                });

                //doc.autoTable(exportColumns, genericasSistema.map(x => x.uts));
                //doc.save('datos.pdf');
            });
        });

        //html ="<html><body>"+html+"</body></html>"
        //html = primeFlexCSS.tostring()+html;


    };


    const ContentReport = () => {

        let tgViewReport = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "VIEW" && x.seccion === "REPORT");

        let gsViewReport = genericasSistema.find(x => x.tg === tgViewReport.tgRef);

        let structReport = gsViewReport.uts;



        return (
            <div dangerouslySetInnerHTML={{ __html: structReport.portadaReporte }} />
        );
    };


    if (selectedTipoGenerica === undefined || !selectedTipoGenerica.tg || !selectedTipoGenerica.tg === "" ||
        selectedTipoGenerica.operaciones === undefined || metadataGenericaSistemaTgOperaciones === undefined
        || metadataGenericaSistemaTgOperaciones.length === 0
        || genericasSistema === null || genericasSistema.length === 0
        || genericaFormulario === undefined
        || optionsSelectButton === undefined) { //|| selectedTipoGenericaFormulario === undefined) {

        //|| metadataGenericaSistema.length === 0
        return (<DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
            <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
            <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate}></Column>
        </DataTable>)
    }


    else if (selectedTipoGenerica.operaciones === undefined) {

        return (<span>No se encuentran permisos asociados</span>)
    }

    else {

        let tgViewReport = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "VIEW" && x.seccion === "REPORT");


        let gsViewReport = genericasSistema.find(x => x.tg === tgViewReport.tgRef);

        if (gsViewReport !== undefined && gsViewReport !== null) {

            //<iframe src={selectedTipoGenerica.referencia1} height="400rem" width="100%"></iframe>,
            //<iframe src={urlExterna} height="400rem" width="100%"></iframe>
            return (<>


                <GeneratePdf selectedTipoGenerica={selectedTipoGenerica}
                    genericasSistema={genericasSistema} metadata={metadataGenericaSistema}
                />

            </>);

        }
        else {
            return (<>
                <div>
                    Reporte no configurados correctamente
                </div>
            </>);
        }

    }



}


export default Reporte;

